// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2SdxJ","actionsCol":"EnrolledClinics_actionsCol__SzNrp"};